import React, { useState, useContext, useEffect, useRef, useMemo, useCallback, lazy, Suspense } from "react";
import { useTranslation } from 'react-i18next';
import './style.css';
import './styleResponsive.css';
import './styleModern.css';
import './modernStyle.css';
import '../../styles/page-titles.css';
import styled from 'styled-components';
import { IoStorefrontOutline } from "react-icons/io5";
import PhoneInput from '../../components/PhoneInput';
import { toE164, fromE164, localDigitsFromE164, formatPhoneDisplay } from '../../utils/phone';
import { toast } from "react-toastify";
import { getStoredUser } from '../../utils/safeStorage';
import { SidebarContext } from "../../AppRoutes";
import { registerPedido, getCategorias, getItens, getVinculoEmpresa, getAdicionaisCardapio, getCliente, getClienteByName, registerClienteFromCardapio } from "../../services/api";
import { saveToLocalStorage, getFromLocalStorage } from '../../utils/localStorage';
import PermissionGate from "../../services/PermissionGate";
import regionConfig from '../../config/regionConfig';

import { AiOutlineSearch } from "react-icons/ai";
import { MdFastfood } from "react-icons/md";
import SafeImage from "../../components/SafeImage";
import { MdShoppingCartCheckout } from "react-icons/md";
import { MdFlashOn } from "react-icons/md";
import { MdDeliveryDining } from "react-icons/md";
import Loading from "react-loading";
import { formatPrice } from "../../utils/formatPrice";
import { formatPriceWithSymbol } from "../../utils/currency";

// Lazy load dos modais (somente montados quando abertos)
const ModalAdicionais = lazy(() => import('./ModalAdicionais'));
const ModalAddObsPedido = lazy(() => import('./ModalAddObsPedido'));
const ModalAddObsItem = lazy(() => import('./ModalAddObsItem'));
const ModalEntregaPdv = lazy(() => import('./ModalEntregaPdv'));
const ModalPagamentos = lazy(() => import('./ModalPagamentos'));
const ModalCpfCnpj = lazy(() => import('./ModalCpfCnpj'));
const ModalDesconto = lazy(() => import('./ModalDesconto'));

const Teste = styled.div`
    display: flex;
    margin-left: ${({ sidebar }) => (sidebar ? '250px' : '100px')};
    height: calc(100vh - var(--navbar-height, 56px) - 24px);
    width: auto;
    transition: 150ms;
    background-color: rgb(255,255,255)!important;
    overflow: initial;
    z-index: 9;

    @media (max-width: 880px) {
        margin-left: 0;
    }
`;

// Funde um item novo no carrinho: agrupa com um item idêntico existente (mesmo
// produto + mesmos adicionais + mesma obs, via uniqueId) somando quantidade, ou
// adiciona como linha nova. Usada por handleItemClick (produto simples) e
// handleFinalizarAdicionais (produto com adicional) - todo clique vai direto
// pro carrinho real, sem etapa de staging.
const mergeItemNoCarrinho = (carrinhoAtual, itemNovo) => {
    let adicionaisAtualizados = [];
    if (itemNovo.adicionais && Array.isArray(itemNovo.adicionais)) {
        adicionaisAtualizados = itemNovo.adicionais.map(grupo => ({
            ...grupo,
            calcular_maior_valor: grupo?.calcular_maior_valor ?? false,
            calcular_media: grupo?.calcular_media ?? false,
        }));
    }

    const itemAtualizado = {
        ...itemNovo,
        adicionais: adicionaisAtualizados,
        uniqueId: generateUniqueItemId({ ...itemNovo, adicionais: adicionaisAtualizados })
    };

    const updatedCarrinho = [...carrinhoAtual];
    const existingItemIndex = updatedCarrinho.findIndex(i => i.uniqueId === itemAtualizado.uniqueId);

    if (existingItemIndex > -1) {
        updatedCarrinho[existingItemIndex] = {
            ...updatedCarrinho[existingItemIndex],
            quantity: updatedCarrinho[existingItemIndex].quantity + itemNovo.quantity,
            adicionais: (updatedCarrinho[existingItemIndex].adicionais &&
                Array.isArray(updatedCarrinho[existingItemIndex].adicionais) &&
                itemNovo.adicionais && Array.isArray(itemNovo.adicionais))
                ? updatedCarrinho[existingItemIndex].adicionais.map((grupo, groupIndex) => ({
                    ...grupo,
                    adicionais: (grupo?.adicionais && Array.isArray(grupo.adicionais))
                        ? grupo.adicionais.map((adicional, adicionalIndex) => {
                            const itemNovoAdicional = itemNovo.adicionais[groupIndex]?.adicionais?.[adicionalIndex];
                            return {
                                ...adicional,
                                quantity: adicional.quantity + (itemNovoAdicional?.quantity || 0)
                            };
                        })
                        : grupo.adicionais
                }))
                : updatedCarrinho[existingItemIndex].adicionais
        };
    } else {
        updatedCarrinho.push(itemAtualizado);
    }

    return updatedCarrinho;
};

// Função para gerar ID único baseado no item e seus adicionais
const generateUniqueItemId = (item) => {
    let adicionaisString = '';
    
    if (item.adicionais && Array.isArray(item.adicionais)) {
        try {
            adicionaisString = JSON.stringify(item.adicionais.map(grupo => ({
                grupoId: grupo?.grupoId || '',
                adicionais: (grupo?.adicionais && Array.isArray(grupo.adicionais)) ? grupo.adicionais.map(add => ({
                    adicionalId: add?.adicionalId || '',
                    quantity: (add?.quantity && add.quantity > 0) ? add.quantity : 0
                })).filter(add => add.quantity > 0) : []
            })).filter(grupo => grupo.adicionais.length > 0));
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.warn('Erro ao processar adicionais para uniqueId:', error);
            adicionaisString = '';
        }
    }
    
    const obsString = item.obs_item || '';
    const baseString = adicionaisString + obsString;
    
    try {
        return `${item._id}_${btoa(baseString).replace(/[^a-zA-Z0-9]/g, '')}`;
    } catch (error) {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.warn('Erro ao gerar uniqueId:', error);
        return `${item._id}_${Date.now()}`;
    }
};

const Pdv = () => {
    const { t } = useTranslation(['pdv', 'common']);
    const userParse = getStoredUser();
    const userID = userParse?._id;
    //const empresa = localStorage.getItem('empresa');
    //const empresaParse = JSON.parse(empresa);
    //const empresaObjId = empresaParse._id;
    //const idEmpresa = empresaParse.id_empresa;
    //const vinculo_empresa = empresaParse.cnpj;
    const [empresa, setEmpresa] = useState(null);


    const [idEmpresa, setIdEmpresa] = useState(null);


    const nomeEmpresaForUrl = empresa?.name.replace(/ /g, '-').toLowerCase();
    const enderecoEmpresa = empresa ? {
        bairro: empresa.bairro,
        cidade: empresa.municipio,
        estado: empresa.estado,
        numero: empresa.address_number,
        rua: empresa.logradouro
    } : null;
    const { sidebar } = useContext(SidebarContext);
    const [categorias, setCategorias] = useState([]);
    const [itens, setItens] = useState([]);
    const [selectedCategoria, setSelectedCategoria] = useState("");
    //const [celularCliente, setCelularCliente] = useState("");
    const [nomeCliente, setNomeCliente] = useState("");
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [telefone, setTelefone] = useState('');
    const [clientes, setClientes] = useState([]);
    const [itensCarrinho, setItensCarrinho] = useState(getFromLocalStorage('itensCarrinho') || []);
    const [editarPedido, setEditarPedido] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const containerRef = useRef(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [showAdicionaisModal, setShowAdicionaisModal] = useState(false);
    const [editingCartItem, setEditingCartItem] = useState(null); // item do carrinho cujos adicionais estão sendo editados (null = adicionando novo)

    const [adicionaisCompletos, setAdicionaisCompletos] = useState([]);  // Adicione este estado
    const [quantidades, setQuantidades] = useState({});  // Adicione este estado
    const [showModalAddObsPedido, setShowModalAddObsPedido] = useState(true);

    const [itemSelecionadoParaObs, setItemSelecionadoParaObs] = useState(null);
    const [obsItem, setObsItem] = useState("");
    const [showModalAddObsItem, setShowModalAddObsItem] = useState(true);
    const [showModalEntregaPdv, setShowModalEntregaPdv] = useState(true);
    const [formaEntrega, setFormaEntrega] = useState(null);
    const [showModalPagamentos, setShowModalPagamentos] = useState(true);
    const [formaPagamento, setFormaPagamento] = useState("Dinheiro");
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [valorEntrega, setValorEntrega] = useState(0);
    const [savedFormaEntrega, setSavedFormaEntrega] = useState(null);
    // Distingue "Pedido Rápido" (defaults tudo, finaliza com 1 clique) de uma
    // Retirada escolhida deliberadamente (ainda pede pagamento no modal).
    // Ambos usam o mesmo formato de savedFormaEntrega - só este flag diferencia.
    const [modoRapido, setModoRapido] = useState(false);
    const [showModalCpfCnpj, setShowModalCpfCnpj] = useState(true);
    const [cpfCnpjValue, setCpfCnpjValue] = useState('');
    const [desconto, setDesconto] = useState(0);
    const [showModalDesconto, setShowModalDesconto] = useState(false);

    const [loading, setLoading] = useState(true); // Estado de carregamento
    const [isSubmittingOrder, setIsSubmittingOrder] = useState(false); // Estado para prevenir múltiplos cliques
    const [searchTerm, setSearchTerm] = useState("");

    // Memo para evitar sort a cada render
    const categoriasSorted = useMemo(() => {
        if (!Array.isArray(categorias)) return [];
        return [...categorias].sort((a, b) => a.order - b.order);
    }, [categorias]);

    const itensSorted = useMemo(() => {
        if (!Array.isArray(itens)) return [];
        return [...itens].sort((a, b) => a.order - b.order);
    }, [itens]);

    // Itens filtrados por busca (nome/descrição)
    const itensFiltered = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return itensSorted;
        return itensSorted.filter((item) => {
            const haystack = `${item.title || ''} ${item.description || ''}`.toLowerCase();
            return haystack.includes(term);
        });
    }, [itensSorted, searchTerm]);


    useEffect(() => {
        let isMounted = true;

        const fetchEmpresa = async () => {
            try {
                const response = await getVinculoEmpresa(userID);
                if (response.data.vinculo) {
                    const vinculo = response.data.vinculo;
                    if (isMounted) {
                        setEmpresa(vinculo);
                        setIdEmpresa(vinculo.id_empresa);
                        const categoriaTemp = await getCategorias();
                        const itemTemp = await getItens();
                        if (isMounted) {
                            setCategorias(categoriaTemp.data.categorias);
                            setItens(itemTemp.data.itens);
                            setLoading(false); // Dados carregados, definir loading como falso
                        }
                    }
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao buscar dados:", error);
                if (isMounted) {
                    setLoading(false); // Em caso de erro, definir loading como falso
                }
            }
        };

        fetchEmpresa();

        return () => {
            isMounted = false;
        };
    }, [userID]);

    useEffect(() => {
        // Se o carrinho está vazio, apenas salva vazio no localStorage
        if (itensCarrinho.length === 0) {
            saveToLocalStorage('itensCarrinho', []);
            return;
        }

        // Garante que todos os itens tenham uniqueId ao carregar
        const itensComUniqueId = itensCarrinho.map(item => {
            if (!item.uniqueId) {
                return {
                    ...item,
                    uniqueId: generateUniqueItemId(item)
                };
            }
            return item;
        });
        
        // Só atualiza se houver diferença
        if (JSON.stringify(itensComUniqueId) !== JSON.stringify(itensCarrinho)) {
            setItensCarrinho(itensComUniqueId);
            return; // Não salva agora, vai salvar na próxima execução do useEffect
        }
        
        // Salva no localStorage apenas se não houve mudança na estrutura
        saveToLocalStorage('itensCarrinho', itensCarrinho);
    }, [itensCarrinho]);

    const fetchAdicionais = useCallback(async (item) => {
        try {
            const response = await getAdicionaisCardapio(idEmpresa, nomeEmpresaForUrl);
            const adicionaisFromDB = response.data.adicionais;
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Adicionais do item", item.adicionais)
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("adicionaisFromDB:",adicionaisFromDB)
            if (item.adicionais && adicionaisFromDB) {
                const adicionaisEncontrados = adicionaisFromDB.filter(adicionalDB =>
                    item.adicionais.some(adicionalItem => adicionalItem.value === adicionalDB._id),
                    //item.adicionais.some(adicionalItem => !adicionalItem.out)
                );
                // Tipo A: ordenar os grupos pela ordem definida no item (drag-and-drop)
                const __ordemGruposItem = item.adicionais.map(a => String(a.value));
                adicionaisEncontrados.sort((a, b) => __ordemGruposItem.indexOf(String(a._id)) - __ordemGruposItem.indexOf(String(b._id)));
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("adicionaisEncontrados>>", adicionaisEncontrados)
                // Verifica se existe ao menos um subAdicional com out === false
                const temSubAdicionalDisponivel = adicionaisEncontrados.some(adicional =>
                    adicional.adicionais.some(subAdicional => !subAdicional.out)
                );

                // Se encontrou pelo menos um subAdicional disponível, abre o modal
                if (temSubAdicionalDisponivel) {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Caiu aqui 1 ?");
                    setAdicionaisCompletos(adicionaisEncontrados);
                    setQuantidades({}); // Resetar as quantidades ao abrir o modal
                    setShowAdicionaisModal(true); // Abre o modal se adicionais forem encontrados
                } else {
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Caiu aqui 2 ?");
                    process.env.REACT_APP_ISDEVELOP === 'true' && console.log("ITEMMM>>>", item);
                    if(item.type==="pizza"){
                        toast(t('pdv:pizzaNoFlavors'), { autoClose: 2000, type: "warning" });
                        return;
                    }
                    // Sem subAdicional disponível apesar de has_adicional=true: trata como produto simples
                    setItensCarrinho(prevCarrinho => mergeItemNoCarrinho(prevCarrinho, { ...item, quantity: 1 }));
                }

            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao buscar adicionais:', error);
        }
    }, [idEmpresa, nomeEmpresaForUrl]);

    // Função de handleFinalizar para o ModalAdicionais
    const handleFinalizarAdicionais = (item, selectedAdicionais) => {
        if (editingCartItem) {
            // Editando os adicionais de um item que JÁ está no carrinho
            const updatedCarrinho = itensCarrinho.map(ci => {
                if (ci.uniqueId === editingCartItem.uniqueId) {
                    const itemAtualizado = { ...ci, adicionais: selectedAdicionais };
                    // Regenera o uniqueId pois ele depende dos adicionais
                    return { ...itemAtualizado, uniqueId: generateUniqueItemId(itemAtualizado) };
                }
                return ci;
            });
            setItensCarrinho(updatedCarrinho);
            saveToLocalStorage('itensCarrinho', updatedCarrinho);
            toast(t('pdv:messages.editComplete'), { autoClose: 1500, type: 'success' });
        } else {
            // Item novo: vai direto pro carrinho real (mesmo padrão de handleItemClick).
            const novoItem = { ...item, adicionais: selectedAdicionais, quantity: 1 };
            setItensCarrinho(prevCarrinho => mergeItemNoCarrinho(prevCarrinho, novoItem));
            toast(t('pdv:editOrder.itemsSentToCart'), { autoClose: 1000, type: 'success' });
        }
        setShowAdicionaisModal(false);
        setSelectedItem(null);
        setEditingCartItem(null);
        setQuantidades({});
        setAdicionaisCompletos([]);
    };

    // Abre o modal de adicionais para EDITAR um item que já está no carrinho.
    // A definição dos grupos vem do item do cardápio; as quantidades vêm das seleções atuais do item.
    const handleEditarAdicionaisCarrinho = useCallback(async (produtos) => {
        try {
            const menuItem = itens.find(it => it._id === produtos._id);
            let definicao = (menuItem && Array.isArray(menuItem.adicionais)) ? menuItem.adicionais : null;
            if (!definicao || definicao.length === 0) {
                // Fallback: usa os grupos já presentes nas seleções atuais do item.
                definicao = (produtos.adicionais || []).map(g => ({ value: g.grupoId }));
            }

            // Pré-preenche as quantidades a partir das seleções atuais do item.
            const quantidadesIniciais = {};
            (produtos.adicionais || []).forEach(grupo => {
                (Array.isArray(grupo.adicionais) ? grupo.adicionais : []).forEach(sub => {
                    if (sub && sub.adicionalId && sub.quantity > 0) {
                        quantidadesIniciais[sub.adicionalId] = sub.quantity;
                    }
                });
            });

            // Busca os grupos de adicionais disponíveis para o item.
            const response = await getAdicionaisCardapio(idEmpresa, nomeEmpresaForUrl);
            const adicionaisFromDB = response.data.adicionais || [];
            const adicionaisEncontrados = adicionaisFromDB.filter(adicionalDB =>
                definicao.some(a => a.value === adicionalDB._id)
            );
            // Tipo A: ordenar os grupos pela ordem definida no item (drag-and-drop)
            const __ordemGruposDef = definicao.map(a => String(a.value));
            adicionaisEncontrados.sort((a, b) => __ordemGruposDef.indexOf(String(a._id)) - __ordemGruposDef.indexOf(String(b._id)));

            setQuantidades(quantidadesIniciais);
            setAdicionaisCompletos(adicionaisEncontrados);
            // O modal usa selectedItem.adicionais como DEFINIÇÃO para montar os grupos.
            setSelectedItem({ ...produtos, adicionais: definicao });
            setEditingCartItem(produtos);
            setShowAdicionaisModal(true);
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao abrir adicionais do item do carrinho:', error);
            toast(t('pdv:cart.editAddonsError', { defaultValue: 'Não foi possível abrir os adicionais deste item.' }), { autoClose: 2000, type: 'error' });
        }
    }, [itens, idEmpresa, nomeEmpresaForUrl, t]);

    /*const handleItemClick = (item) => {
        setSelectedItem(item);
        if (item.has_adicional) {
            fetchAdicionais(item);
        } else {
            incrementCount(item);
        }
    };*/
    const handleItemClick = useCallback((item) => {
        if (item.has_adicional || item.type === "pizza") {
            setSelectedItem(item);
            fetchAdicionais(item);
        } else {
            // Produto simples (sem adicional): vai direto pro carrinho real a cada
            // clique, igual ao fluxo de adicionais - sem etapa de "selecionar" antes.
            setItensCarrinho(prevCarrinho => mergeItemNoCarrinho(prevCarrinho, { ...item, quantity: 1 }));
        }
    }, [fetchAdicionais]);


    const handleAddObsPedido = (item) => {
        //toast("Observação adicionada", { autoClose: 2000, type: "success" });
        setShowModalAddObsPedido(!showModalAddObsPedido);
    }

    const handleAddObsItem = (item) => {
        setItemSelecionadoParaObs(item);
        setObsItem(item.obs_item || "");
        setShowModalAddObsItem(!showModalAddObsItem); // Presumo que você já tenha o modal configurado
    };

    const handleSaveObsItem = () => {
        const updatedCarrinho = itensCarrinho.map(prod => {
            // Usa uniqueId para identificar o item específico
            if (prod.uniqueId === itemSelecionadoParaObs.uniqueId) {
                const itemComObs = { ...prod, obs_item: obsItem };
                // Regenera uniqueId pois a observação mudou
                return {
                    ...itemComObs,
                    uniqueId: generateUniqueItemId(itemComObs)
                };
            }
            return prod;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
        setShowModalAddObsItem(false);
        toast(t('pdv:editOrder.obsAdded'), { autoClose: 2000, type: "success" });
    };

    const [valueDescricao, setValueDescricao] = useState('');

    const handleRemoveItem = (item) => {
        if (selectedPayment) {
            setSelectedPayment(null);
        }
        // Usa uniqueId para remover apenas o item específico
        const updatedCarrinho = itensCarrinho.filter(prod => prod.uniqueId !== item.uniqueId);
        setItensCarrinho(updatedCarrinho);
        // O useEffect vai cuidar de salvar no localStorage
        toast(t('pdv:editOrder.itemRemoved'), { autoClose: 1000, type: "success" });
    };



    const normalizePhoneNumber = (phone) => {
        return phone.replace(/[^\d]/g, ''); // Remove todos os caracteres não numéricos
    };

    const fetchClientes = async (inputValue, searchType = 'phone') => {
        /*if (inputValue.length < 4) {
            setClientes([]);
            return [];
        }*/

        try {
            let response;
            if (searchType === 'phone') {
                response = await getCliente(idEmpresa, normalizePhoneNumber(inputValue));
            } else {
                // Busca por nome
                response = await getClienteByName(idEmpresa, inputValue);
            }
            ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("response.data>>", response.data);
            if (response.status === 200) {
                const clientesData = response.data.clientes.map(cliente => ({
                    ...cliente // Inclui todos os demais dados do cliente
                }));
                setClientes(clientesData);
                return clientesData;
            }
            setClientes([]);
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao buscar clientes:", error);
            setClientes([]);
            return [];
        }
    };

    /*useEffect(() => {
        // Carregar todos os clientes inicialmente ou quando necessário
        fetchClientes('');
    }, []);*/

    const handleNomeChange = async (event) => {
        const inputValue = event.target.value;
        setNomeCliente(inputValue);

        // Busca por nome se tiver pelo menos 2 caracteres após trim
        const normalizedName = inputValue.trim();
        if (normalizedName.length >= 2) {
            await fetchClientes(inputValue, 'name');
        } else {
            setClientes([]);
        }

        // Se não há cliente selecionado ou o nome mudou, limpa a seleção
        if (!selectedCliente || selectedCliente.nome !== inputValue) {
            setSelectedCliente({
                ...selectedCliente,
                nome: inputValue
            });
        }
        //////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("PASSOU AQUI TESTE!");
    };

    const handleTelefoneChange = async (val) => {
        setTelefone(val || '');

        // Validar se tem pelo menos 3 dígitos após normalização
        const digits = localDigitsFromE164(val);
        if (digits.length >= 3) {
            await fetchClientes(digits, 'phone');
        } else {
            setClientes([]);
        }
        setSelectedCliente(null);
        setNomeCliente("");
    };

    const handleClienteClick = (cliente) => {
        //////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("ENTROU AQUI? cliente>>", cliente);
        setSelectedCliente(cliente);
        setNomeCliente(cliente.nome);
        setTelefone(toE164(cliente.telefone_completo || cliente.telefone));
        setClientes([]); // Limpa a lista após seleção
    };

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setClientes([]); // Limpa a lista se clicar fora
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (telefone === "") {
            setSelectedCliente(null);
        }
    }, [telefone]);

    // Decrementa (ou remove, se chegar a 0) um produto simples direto no carrinho
    // real - contraparte de handleItemClick para o stepper "-" do card do grid.
    const decrementSimpleItemNoCarrinho = (item) => {
        setItensCarrinho(prevCarrinho => prevCarrinho.reduce((acc, i) => {
            if (i._id === item._id) {
                if (i.quantity > 1) {
                    acc.push({ ...i, quantity: i.quantity - 1 });
                }
                return acc;
            }
            acc.push(i);
            return acc;
        }, []));
    };

    const subTotal = useMemo(() => Array.isArray(itensCarrinho) ? itensCarrinho.reduce((sum, item) => {
        const adicionaisSum = Array.isArray(item.adicionais) ? item.adicionais.reduce((acc, grupo) => {
            if (grupo.calcular_maior_valor) {
                const maxAdicionalValue = Array.isArray(grupo.adicionais)
                    ? Object.values(
                        grupo.adicionais.reduce((acc, adicional) => {
                            // Agrupando adicionais pelo `adicionalId`
                            if (!acc[adicional.adicionalId]) {
                                acc[adicional.adicionalId] = {
                                    ...adicional,
                                    total: adicional.price //* adicional.quantity
                                };
                            } else {
                                acc[adicional.adicionalId].total += adicional.price //* adicional.quantity;
                            }
                            return acc;
                        }, {})
                    ).reduce((max, adicional) => {
                        // Considerando o maior valor entre os totais dos adicionais
                        return adicional.total > max ? adicional.total : max;
                    }, 0)
                    : 0;
                return acc + maxAdicionalValue;
            } else if (grupo.calcular_media) {
                // Calcular a média dos adicionais selecionados dentro do grupo
                const adicionaisSelecionados = Array.isArray(grupo.adicionais)
                    ? grupo.adicionais.filter(adicional => adicional.quantity > 0)
                    : [];

                if (adicionaisSelecionados.length > 0) {
                    // Soma os valores dos adicionais selecionados e calcula a média
                    const somaValores = adicionaisSelecionados.reduce((subAcc, adicional) => {
                        return subAcc + (adicional.price * adicional.quantity);
                    }, 0);
                    const mediaValor = somaValores / adicionaisSelecionados.length; // Média
                    return acc + mediaValor;
                }
                return acc; // Caso não haja adicionais selecionados, não altera o total

            } else {
                // Caso contrário, somamos todos os valores dos adicionais do grupo.
                const totalAdicionais = Array.isArray(grupo.adicionais)
                    ? grupo.adicionais.reduce((subAcc, adicional) => {
                        return subAcc + (adicional.price * adicional.quantity);
                    }, 0)
                    : 0;
                return acc + totalAdicionais;
            }
        }, 0) : 0;

        // Adicionais são sempre POR UNIDADE, multiplicam pela quantidade (modelo iFood)
        return sum + (item.price + adicionaisSum) * item.quantity;
    }, 0) : 0, [itensCarrinho]);


    const safeSubTotal = isNaN(Number(subTotal)) ? 0 : Number(subTotal);
    const safeValorEntrega = savedFormaEntrega && !isNaN(Number(savedFormaEntrega.valorEntrega))
        ? Number(savedFormaEntrega.valorEntrega)
        : 0;

    // Reset discount if it exceeds subtotal (e.g. items removed from cart)
    useEffect(() => {
        if (desconto > 0 && desconto > safeSubTotal) {
            setDesconto(0);
        }
    }, [safeSubTotal, desconto]);

    const valorTotal = safeSubTotal + safeValorEntrega - desconto;

    const renderAdicionais = (item, adicionais) => {
        if (!adicionais || !Array.isArray(adicionais)) return null;
        const itemQty = item.quantity || 1;
        return adicionais.map(grupo => (
            <div key={grupo.grupoId} className="adicionais-group">
                <span style={{ fontWeight: 'bold' }}>{grupo.grupoTitle}</span>
                {Array.isArray(grupo.adicionais) && grupo.adicionais.map(adicional => (
                    <div key={adicional.adicionalId} className="adicional-item">
                        <span className="titleAdicionalCart">{adicional.title} (
                            {grupo.calcular_maior_valor || grupo.calcular_media
                                ? (adicional.quantity * itemQty) > grupo.adicionais.length
                                    ? `${grupo.adicionais.length}/${grupo.adicionais.length}`
                                    : `${adicional.quantity * itemQty}/${grupo.adicionais.length}`
                                : `x${adicional.quantity * itemQty}`
                            })
                        </span>
                        <div className="line" />
                        <span style={{ minWidth: 60 }}>
                            {
                                grupo.calcular_media
                                    ? formatPriceWithSymbol(
                                        (grupo.adicionais.reduce((acc, subAdicional) => acc + (subAdicional.price * subAdicional.quantity), 0) /
                                        grupo.adicionais.reduce((acc, subAdicional) => acc + subAdicional.quantity, 0) / grupo.adicionais.length) * itemQty
                                    )
                                    : grupo.calcular_maior_valor
                                        ? adicional.price === Math.max(...grupo.adicionais.map(subAdicional => subAdicional.price))
                                            ? formatPriceWithSymbol(Math.max(...grupo.adicionais.map(subAdicional => subAdicional.price)) * itemQty)
                                            : formatPriceWithSymbol(0)
                                        : formatPriceWithSymbol(adicional.price * adicional.quantity * itemQty)
                            }
                        </span>
                    </div>
                ))}
            </div>
        ));
    };






    const handleScrollOnClick = (mongodbId) => {
        const element = document.getElementById(mongodbId);
        if (element) {
            setSelectedCategoria(mongodbId);
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    const handleEditaPedido = () => {
        setEditarPedido(true);
    };

    const handleConcluirEdicao = () => {
        toast(t('pdv:messages.editComplete'), { autoClose: 2000, type: "success" });
        saveToLocalStorage('itensCarrinho', itensCarrinho);
        setEditarPedido(false);
    };

    const handleChangeLocalStorage = (e, item) => {
        const newQuantity = parseInt(e.target.value, 10);
        if (isNaN(newQuantity) || newQuantity < 0) return;

        const updatedCarrinho = itensCarrinho.map(i => {
            // Usa uniqueId para identificar o item específico
            if (i.uniqueId === item.uniqueId) {
                return { ...i, quantity: newQuantity };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    const incrementCountLocalStorage = (item) => {
        const updatedCarrinho = itensCarrinho.map(i => {
            // Usa uniqueId para identificar o item específico
            if (i.uniqueId === item.uniqueId) {
                return {
                    ...i,
                    quantity: i.quantity + 1,
                    adicionais: i.adicionais ? i.adicionais.map(grupo => ({
                        ...grupo,
                        calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                        calcular_media: grupo.calcular_media ?? false,
                        adicionais: (grupo.adicionais || []).map(adicional => ({
                            ...adicional,
                            quantity: adicional.quantity // Mantém a quantidade dos adicionais
                        }))
                    })) : []
                };
            }
            return i;
        });
    
        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    const decrementCountLocalStorage = (item) => {
        const updatedCarrinho = itensCarrinho.reduce((acc, i) => {
            // Usa uniqueId para identificar o item específico
            if (i.uniqueId === item.uniqueId) {
                if (i.quantity > 1) {
                    acc.push({
                        ...i,
                        quantity: i.quantity - 1,
                        adicionais: i.adicionais ? i.adicionais.map(grupo => ({
                            ...grupo,
                            calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                            calcular_media: grupo.calcular_media ?? false,
                            adicionais: grupo.adicionais ? grupo.adicionais.map(adicional => ({
                                ...adicional,
                                quantity: adicional.quantity // Mantém a quantidade dos adicionais
                            })) : []
                        })) : []
                    });
                }
                // Se a quantidade for 1, não adiciona de volta para `acc`, efetivamente removendo-o
            } else {
                acc.push(i);
            }
            return acc;
        }, []);

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    useEffect(() => {
        if (itensCarrinho.length === 0) {
            setEditarPedido(false);
        }
    }, [itensCarrinho]);

    const handleDeletePedido = () => {
        setItensCarrinho([]);
        setEditarPedido(false);
        setValueDescricao('');
        toast(t('pdv:messages.itemsDeleted'), { autoClose: 2500, type: "success" });
    };

    const handleClickEntrega = async (tipoPreSelecionado) => {
        setModoRapido(false);
        setSelectedPayment(null);
        setShowModalEntregaPdv(!showModalEntregaPdv)
        if (tipoPreSelecionado) {
            setFormaEntrega(tipoPreSelecionado);
        }
        try {
            // Identificação do cliente é opcional: sem nome/telefone digitados, usa o
            // mesmo sentinela do "Não informado" em vez de bloquear o cadastro (o
            // endpoint exige ambos os campos preenchidos).
            const nomeParaRegistro = (nomeCliente && nomeCliente.trim() !== '') ? nomeCliente : t('pdv:customer.notInformed');
            const telefoneParaRegistro = (telefone && telefone.trim() !== '') ? fromE164(telefone) : "(00) 0 0000-0000";
            const response = await registerClienteFromCardapio(idEmpresa, nomeParaRegistro, telefoneParaRegistro);
            if (response.status === 201) {
                let cliente = response.data.cliente;
                ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("response:", cliente);
                setSelectedCliente(cliente)
            }
        } catch (error) {
            ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("error:",error);
        }

    }

    const handleSubmitAPI = (paymentOverride) => {
        // Previne múltiplos cliques
        if (isSubmittingOrder) {
            return;
        }

        // paymentOverride: usado quando o ModalPagamentos chama de volta assim que
        // o operador confirma o pagamento (fluxo "Continuar" -> finaliza sozinho,
        // sem precisar de um segundo clique fora do modal). Sem override, usa o
        // state normal (chamada antiga, mantida por compatibilidade).
        const payment = paymentOverride || selectedPayment;
        if (!payment) {
            return;
        }

        const createdBy = userID;
        const itens = itensCarrinho.map(item => {
            const { _id, title, price, quantity, adicionais, obs_item } = item;
            return { objIdItem: _id, nomeItem: title, valor: price, quantidade: quantity, grupo_adicionais: adicionais, obs_item };
        });
        if (itens.length === 0) {
            toast(t('pdv:messages.emptyCartWarning'), { autoClose: 3000, type: "warning" });
            return;
        }

        // Inicia o estado de loading
        setIsSubmittingOrder(true);

        // Identificação do cliente é opcional em qualquer tipo de pedido (Entrega,
        // Retirada ou Rápido): sem nome/telefone digitados, cai no sentinela - o
        // backend exige os dois campos não vazios (/auth/registerPedido), então
        // nunca manda string vazia.
        const celular_cliente = (telefone && telefone.trim() !== '') ? fromE164(telefone) : "(00) 0 0000-0000";
        const nome_cliente = (nomeCliente && nomeCliente.trim() !== '') ? nomeCliente : t('pdv:customer.notInformed');
        const tipo_pagamento = payment.paymentType === 'Cartao' ? 'Cartão' : payment.paymentType;
        // Recomendação: caso existam valores como "Cartao" vindos do modal,
        // garantir normalização ao salvar o pedido no backend.
        // Ex.: import { normalizePaymentType } from "../../utils/normalizePaymentType" e aplicar aqui.
        const entrega = {
            tipo_entrega: savedFormaEntrega.formaEntrega,
            endereco: savedFormaEntrega.selectedAddress ? savedFormaEntrega.selectedAddress : enderecoEmpresa,
            valor: savedFormaEntrega.valorEntrega
        };
        const descontoValue = desconto;
        const cpf_cnpj = cpfCnpjValue;
        const valor_troco = payment.paymentType === "Dinheiro" ? payment.valorTroco : 0;
        const valor_total = valorTotal;
        const descricao = valueDescricao;
        /*process.env.REACT_APP_ISDEVELOP === 'true' && console.log({
            createdBy,
            idEmpresa,
            itens,
            celular_cliente,
            nome_cliente,
            tipo_pagamento,
            entrega,
            desconto,
            cpf_cnpj,
            valor_troco,
            valor_total,
            descricao
        })*/
        // ✅ Gerar chave de idempotência para PDV
        const idempotencyKey = `pdv_${idEmpresa}_${celular_cliente}_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;

        // Parcelas do dividido. Manda so a chave do tipo e numeros -- o rotulo
        // (`type`) e traduzido e nao pode virar dado persistido.
        const pagamentos_divididos = payment.paymentType === 'Dividido'
            ? (payment.pagamentosDivididos || []).map((p) => ({
                tipo: p.tipo,
                valor: Number(p.value) || 0,
                troco: Number(p.troco) || 0,
            }))
            : null;

        registerPedido(
            createdBy, idEmpresa, itens, celular_cliente, nome_cliente,
            tipo_pagamento, entrega, descontoValue, cpf_cnpj, valor_troco,
            valor_total, descricao, null, null, idempotencyKey, // external_id, session_token, idempotency_key
            pagamentos_divididos
        ).then(cast => {
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("AQUI DEU BOM, CRIOU PEDIDO:::",cast)
            if (cast.status === 201 || cast.status === 200) { // ✅ Aceitar duplicados também
                localStorage.removeItem('itensCarrinho');
                setValueDescricao('');
                setItensCarrinho([]);
                setSelectedPayment(null);
                setCpfCnpjValue('');
                setSelectedCliente(null);
                setTelefone('');
                setClientes([]);
                setValorEntrega(0);
                setSavedFormaEntrega(null);
                setNomeCliente('');
                setDesconto(0);
                setModoRapido(false);

                toast(cast.data.msg, { autoClose: 5000, type: "success" });
            }
            else {
                toast(cast.data.msg, { autoClose: 5000, type: "error" });
            }

        }).catch(err => {
            ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Oh noooo!!');
            const msg = err.response.data.msg;
            //////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("MENSAGEM", msg)
            toast(msg, { autoClose: 5000, type: "error" });
        }).finally(() => {
            // Sempre finaliza o estado de loading, independente de sucesso ou erro
            setIsSubmittingOrder(false);
        });
    };

    // Pedido Rápido não faz mais uma chamada própria: só marca o modo e já deixa
    // tipo de entrega (Retirada) e pagamento padrão prontos, pra sobrar só UM
    // clique no botão principal (handleSubmitAPI) pra finalizar de verdade -
    // evita o bug de disparar o pedido no clique do botão de tipo.
    const handleSelecionarPedidoRapido = () => {
        // Mesmo formato de Retirada - a diferença é só o destaque visual do botão.
        // "Continuar" abre o modal de pagamento igual nos 3 tipos (Lançar Pagamentos).
        setModoRapido(true);
        setSelectedPayment(null);
        setSavedFormaEntrega({ formaEntrega: "Retirada", valorEntrega: 0, selectedAddress: null });
    };

    const handleSelecionarRetirada = () => {
        setModoRapido(false);
        setSelectedPayment(null);
        setSavedFormaEntrega({ formaEntrega: "Retirada", valorEntrega: 0, selectedAddress: null });
    };

    return (
        <PermissionGate permissions={['default']}>
            {/*<LeftMenu setSidebar={setSidebar} sidebar={sidebar} />*/}
            <Suspense fallback={null}>
                <ModalAddObsPedido showModalAddObsPedido={showModalAddObsPedido}
                    setShowModalAddObsPedido={setShowModalAddObsPedido}
                    itensCarrinho={itensCarrinho}
                    setItensCarrinho={setItensCarrinho}
                    valueDescricao={valueDescricao}
                    setValueDescricao={setValueDescricao}
                />
            </Suspense>
            <Suspense fallback={null}>
                <ModalAddObsItem showModalAddObsItem={showModalAddObsItem}
                    setShowModalAddObsItem={setShowModalAddObsItem}
                    obsItem={obsItem}
                    setObsItem={setObsItem}
                    handleSaveObsItem={handleSaveObsItem}
                />
            </Suspense>
            <Suspense fallback={null}>
                <ModalEntregaPdv showModalEntregaPdv={showModalEntregaPdv}
                    setShowModalEntregaPdv={setShowModalEntregaPdv}
                    formaEntrega={formaEntrega}
                    setFormaEntrega={setFormaEntrega}
                    selectedCliente={selectedCliente}
                    setSelectedCliente={setSelectedCliente}
                    selectedAddress={selectedAddress}
                    setSelectedAddress={setSelectedAddress}
                    empresa={empresa}
                    valorEntrega={valorEntrega}
                    setValorEntrega={setValorEntrega}
                    setSavedFormaEntrega={setSavedFormaEntrega}
                    telefone={telefone}
                    handleTelefoneChange={handleTelefoneChange}
                    nomeCliente={nomeCliente}
                    handleNomeChange={handleNomeChange}
                    clientes={clientes}
                    handleClienteClick={handleClienteClick}
                />
            </Suspense>
            <Suspense fallback={null}>
                <ModalPagamentos showModalPagamentos={showModalPagamentos}
                    setShowModalPagamentos={setShowModalPagamentos}
                    formaPagamento={formaPagamento}
                    setFormaPagamento={setFormaPagamento}
                    selectedPayment={selectedPayment}
                    setSelectedPayment={setSelectedPayment}
                    selectedCliente={selectedCliente}
                    setSelectedCliente={setSelectedCliente}
                    selectedAddress={selectedAddress}
                    setSelectedAddress={setSelectedAddress}
                    empresa={empresa}
                    subTotal={subTotal}
                    valorTotal={valorTotal}
                    savedFormaEntrega={savedFormaEntrega}
                    onPaymentConfirmed={(payment) => handleSubmitAPI(payment)}
                />
            </Suspense>
            {regionConfig.features.cpfCnpj && (
                <Suspense fallback={null}>
                    <ModalCpfCnpj showModalCpfCnpj={showModalCpfCnpj}
                        setShowModalCpfCnpj={setShowModalCpfCnpj}
                        cpfCnpjValue={cpfCnpjValue}
                        setCpfCnpjValue={setCpfCnpjValue}
                    />
                </Suspense>
            )}
            <Teste sidebar={sidebar}>
                {loading && <Loading type={"spinningBubbles"} className="calculandoDistanciaModalEntrega" />}
                <div className="modern-pdv-container">
                    {/* Header moderno */}
                    <div className="modern-pdv-header" style={{paddingBottom:0}}>
                        <div className="header-content">
                            <div className="page-title-with-subtitle">
                                <div className="page-title-with-icon">
                                    <div className="page-icon"><IoStorefrontOutline /></div>
                                    <h1 className="page-title">{t('pdv:title')}</h1>
                                </div>
                                <p className="page-subtitle">{t('pdv:subtitle')}</p>
                            </div>
                            <div className="search-section">
                                <div className="search-containerPDV">
                                    <AiOutlineSearch className="search-icon" />
                                    <input
                                        type="text"
                                        placeholder={t('pdv:search.placeholderFull')}
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="search-inputPDV"
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Layout principal moderno */}
                    <div className="modern-pdv-layout">
                        {/* Seção do cardápio */}
                        <div className="menu-section">
                            <div className="menu-container">
                                <div className="menu-content">
                                    {/* Sidebar de categorias */}
                                    <div className="categories-sidebar">
                                        <div className="categories-header">
                                            <h3>{t('pdv:categories.title')}</h3>
                                        </div>
                                        <div className="categories-list">
                                            {categoriasSorted.filter(cats => itensFiltered.some(item => item.category_item_id === cats._id))
                                                .map(c => (
                                                    <button 
                                                        key={c._id} 
                                                        className={`category-btn ${c._id === selectedCategoria ? 'active' : ''}`}
                                                        onClick={() => handleScrollOnClick(c._id)}
                                                    >
                                                        <span className="category-name">{c.title}</span>
                                                    </button>
                                                ))}
                                        </div>
                                    </div>

                                    {/* Grid de itens */}
                                    <div className="items-grid-container">
                                        {categoriasSorted.filter(category => itensFiltered.some(item => item.category_item_id === category._id))
                                            .map(category => (
                                                <div key={category._id} className="category-section" id={category._id}>
                                                    <div className="category-header">
                                                        <h2 className="category-title">{category.title}</h2>
                                                        <div className="category-line"></div>
                                                    </div>
                                                    <div className="items-grid">
                                                        {itensFiltered.filter(item => item.category_item_id === category._id).map((produtos) => {
                                                            // Produtos sem adicional vão direto pro carrinho real (handleItemClick);
                                                            // o stepper +/- do card reflete a quantidade já lançada lá, não mais
                                                            // um estado de "seleção" à parte.
                                                            const isSimples = !produtos.has_adicional && produtos.type !== 'pizza';
                                                            const itemNoCarrinho = isSimples ? itensCarrinho.find(i => i._id === produtos._id) : null;
                                                            const isOutOfStock = produtos.out;

                                                            return (
                                                                <div
                                                                    key={produtos._id}
                                                                    className={`item-cardPDV ${itemNoCarrinho ? 'selected' : ''} ${isOutOfStock ? 'out-of-stock' : ''}`}
                                                                    onClick={!isOutOfStock ? () => handleItemClick(produtos) : undefined}
                                                                >
                                                                    <div className="item-image">
                                                                        <SafeImage
                                                                            loading="lazy"
                                                                            src={produtos.image}
                                                                            alt={produtos.title}
                                                                            className="product-image"
                                                                            fallback={
                                                                                <div className="placeholder-image">
                                                                                    <MdFastfood className="placeholder-icon" />
                                                                                </div>
                                                                            }
                                                                        />

                                                                        {produtos.type === 'pizza' && !isOutOfStock && (
                                                                            <span className="item-badge item-badge-pizza">{t('pdv:item.pizzaBadge', 'Pizza')}</span>
                                                                        )}

                                                                        {isOutOfStock && (
                                                                            <div className="out-of-stock-overlay">
                                                                                <span className="out-of-stock-text">{t('pdv:item.outOfStock').toUpperCase()}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    <div className="item-info">
                                                                        <h4 className="item-name">{produtos.title}</h4>
                                                                        <p className="item-price">{formatPriceWithSymbol(produtos.price)}</p>
                                                                    </div>

                                                                    {itemNoCarrinho && !isOutOfStock && (
                                                                        <div className="item-controls">
                                                                            <div className="quantity-controls">
                                                                                <button
                                                                                    className="quantity-btn decrease"
                                                                                    onClick={(e) => { e.stopPropagation(); decrementSimpleItemNoCarrinho(produtos); }}
                                                                                    type="button"
                                                                                >
                                                                                    -
                                                                                </button>
                                                                                <span className="quantity">{itemNoCarrinho.quantity}</span>
                                                                                <button
                                                                                    className="quantity-btn increase"
                                                                                    onClick={(e) => { e.stopPropagation(); handleItemClick(produtos); }}
                                                                                    type="button"
                                                                                >
                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Seção do carrinho */}
                        <div className="cart-section">
                            <div className="cart-container">
                                <div className="cart-header">
                                    <h2 className="cart-title">
                                        <MdShoppingCartCheckout className="cart-icon" />
                                        {t('pdv:cart.title')}
                                    </h2>
                                    <div className="cart-actions">
                                        <button
                                            type="button"
                                            onClick={() => handleAddObsPedido()}
                                            className="action-btn secondary"
                                            title={t('pdv:cart.addNote')}
                                        >
                                            {t('pdv:cart.observation')}
                                        </button>
                                        <button
                                            onClick={editarPedido ? handleConcluirEdicao : handleEditaPedido}
                                            className={`action-btn ${editarPedido ? 'primary' : 'secondary'}`}
                                        >
                                            {editarPedido ? t('pdv:cart.done') : t('pdv:cart.edit')}
                                        </button>
                                        <button
                                            onClick={handleDeletePedido}
                                            className="action-btn danger"
                                            disabled={itensCarrinho.length === 0}
                                        >
                                            {t('pdv:cart.clear')}
                                        </button>
                                    </div>
                                </div>

                                {/* Tipo do pedido - escolha logo no início, como no Diggy */}
                                <div className="order-type-row">
                                    <button
                                        className={`order-type-btn order-type-quick ${modoRapido ? 'active' : ''}`}
                                        disabled={itensCarrinho.length === 0 || isSubmittingOrder}
                                        onClick={() => handleSelecionarPedidoRapido()}
                                        title={t('pdv:quickOrder.subtitle')}
                                    >
                                        <MdFlashOn className="order-type-icon" />
                                        <span>{t('pdv:quickOrder.title')}</span>
                                    </button>
                                    <button
                                        className={`order-type-btn ${savedFormaEntrega?.formaEntrega === 'Entrega' ? 'active' : ''}`}
                                        onClick={() => handleClickEntrega('Entrega')}
                                    >
                                        <MdDeliveryDining className="order-type-icon" />
                                        <span>{t('pdv:delivery.deliveryOption')}</span>
                                    </button>
                                    <button
                                        className={`order-type-btn ${savedFormaEntrega?.formaEntrega === 'Retirada' && !modoRapido ? 'active' : ''}`}
                                        onClick={() => handleSelecionarRetirada()}
                                    >
                                        <IoStorefrontOutline className="order-type-icon" />
                                        <span>{t('pdv:delivery.takeaway')}</span>
                                    </button>
                                </div>

                                {/* Informações do cliente - logo após o tipo do pedido */}
                                <div className="customer-info">
                                    <div className="section-title-row">
                                        <h3 className="section-title">{t('pdv:customer.title')}</h3>
                                        <span className="section-subtitle">{t('pdv:customer.optional', 'opcional')}</span>
                                    </div>
                                    <div className="customer-form" ref={containerRef}>
                                        <div className="form-group">
                                            <PhoneInput
                                                id="celular"
                                                name="celular"
                                                className="phone"
                                                onChange={handleTelefoneChange}
                                                value={telefone}
                                                placeholder={regionConfig.identity.phoneMask}
                                                autoComplete="off"
                                            />
                                            <input
                                                type="text"
                                                value={nomeCliente}
                                                onChange={handleNomeChange}
                                                placeholder={t('pdv:search.customerName')}
                                                className="form-input name"
                                                autoComplete="off"
                                            />
                                        </div>

                                        {/* clientes é state compartilhado com a busca de dentro do
                                            ModalEntregaPdv - sem essa checagem, os dois dropdowns
                                            (painel de fundo + modal) apareciam abertos ao mesmo tempo.
                                            showModalEntregaPdv=true aqui significa modal FECHADO (ver
                                            o CSS invertido do componente). */}
                                        {clientes.length > 0 && showModalEntregaPdv && (
                                            <div className="customers-dropdown">
                                                {clientes.map(cliente => (
                                                    <div
                                                        key={cliente._id}
                                                        className="customer-option"
                                                        onMouseDown={() => handleClienteClick(cliente)}
                                                    >
                                                        <span className="customer-phone">{formatPhoneDisplay(cliente.telefone_completo || cliente.telefone)}</span>
                                                        <span className="customer-name">{cliente.nome}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="cart-items">
                                    {!itensCarrinho || itensCarrinho.length === 0 ? (
                                        <div className="empty-cart">
                                            <MdShoppingCartCheckout className="empty-cart-icon" />
                                            <h3>{t('pdv:cart.empty')}</h3>
                                            <p>{t('pdv:cart.emptyMessageFull')}</p>
                                        </div>
                                    ) : (
                                        <div className="cart-items-list">
                                            {itensCarrinho.map((produtos, i) => (
                                                <div key={produtos._id + i} className="cart-item">
                                                    <div className="cart-item-header">
                                                        <div className="item-details">
                                                            <h4 className="cart-item-name">{produtos.title}</h4>
                                                            {produtos.type !== "pizza" && (
                                                                <p className="cart-item-price">
                                                                    {formatPriceWithSymbol(produtos.quantity * produtos.price)}
                                                                </p>
                                                            )}
                                                        </div>
                                                        
                                                        <div className="item-quantity">
                                                            {editarPedido ? (
                                                                <div className="quantity-editor">
                                                                    <button 
                                                                        className="qty-btn decrease"
                                                                        onClick={() => decrementCountLocalStorage(produtos)} 
                                                                        type="button"
                                                                    >
                                                                        -
                                                                    </button>
                                                                    <input 
                                                                        type='number' 
                                                                        onChange={(e) => handleChangeLocalStorage(e, produtos)} 
                                                                        value={produtos.quantity || 0}
                                                                        className="qty-input"
                                                                    />
                                                                    <button 
                                                                        className="qty-btn increase"
                                                                        onClick={() => incrementCountLocalStorage(produtos)} 
                                                                        type="button"
                                                                    >
                                                                        +
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <span className="quantity-display">{produtos.quantity}x</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Adicionais */}
                                                    {renderAdicionais(produtos, produtos.adicionais)}

                                                    {/* Observação do item */}
                                                    {produtos.obs_item && (
                                                        <div className="item-observation">
                                                            <span className="obs-label">{t('pdv:cart.obs')}</span>
                                                            <span className="obs-text">{produtos.obs_item}</span>
                                                        </div>
                                                    )}

                                                    {/* Ações do item */}
                                                    <div className="item-actions">
                                                        {editarPedido && (produtos.has_adicional || produtos.type === 'pizza') && (
                                                            <button
                                                                className="item-action-btn"
                                                                style={{ background: '#eef2ff', color: '#318CD5', border: '1px solid #cfe0f5', fontWeight: 600 }}
                                                                onClick={() => handleEditarAdicionaisCarrinho(produtos)}
                                                                title={t('pdv:cart.editAddons')}
                                                            >
                                                                🍔 {t('pdv:cart.editAddons')}
                                                            </button>
                                                        )}
                                                        <button
                                                            className="item-action-btn observation"
                                                            onClick={() => handleAddObsItem(produtos)}
                                                        >
                                                            {t('pdv:cart.observation')}
                                                        </button>
                                                        <button
                                                            className="item-action-btn remove"
                                                            onClick={() => handleRemoveItem(produtos)}
                                                        >
                                                            {t('pdv:cart.remove')}
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    
                                    {/* Observação do pedido */}
                                    {valueDescricao !== '' && (
                                        <div className="order-observation">
                                            <div className="obs-header">
                                                <span className="obs-icon">📝</span>
                                                <span className="obs-title">{t('pdv:cart.orderObservation')}</span>
                                            </div>
                                            <p className="obs-content">{valueDescricao}</p>
                                        </div>
                                    )}
                                </div>

                                {/* Resumo de valores */}
                                <div className="cart-summary">
                                    <div className="summary-items">
                                        <div className="summary-row">
                                            <span className="summary-label">{t('pdv:cart.subtotal')}</span>
                                            <span className="summary-value">{formatPriceWithSymbol(subTotal)}</span>
                                        </div>
                                        <div className="summary-row">
                                            <span className="summary-label">{t('pdv:cart.discount')}</span>
                                            <span className={`summary-value ${desconto > 0 ? 'discount-active' : ''}`}>
                                                {desconto > 0 ? `-${formatPriceWithSymbol(desconto)}` : formatPriceWithSymbol(0)}
                                            </span>
                                        </div>
                                        <div className="summary-row">
                                            <span className="summary-label">
                                                {t('pdv:delivery.title')}
                                                {savedFormaEntrega?.formaEntrega === "Retirada" && <span className="delivery-type"> - {t('pdv:delivery.pickupAtStore')}</span>}
                                                {savedFormaEntrega?.formaEntrega === "Entrega" && <span className="delivery-type"> - {t('pdv:delivery.delivery')}</span>}
                                            </span>
                                            <span className="summary-value">
                                                {savedFormaEntrega?.formaEntrega === "Entrega"
                                                    ? formatPriceWithSymbol(savedFormaEntrega.valorEntrega)
                                                    : t('pdv:delivery.free')}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="summary-total">
                                        <span className="total-label">{t('pdv:cart.total')}</span>
                                        <span className="total-value">{formatPriceWithSymbol(valorTotal)}</span>
                                    </div>
                                </div>
                                {/* Botões de ação */}
                                <div className="order-actions">
                                    {/* Botões de configuração */}
                                    <div className="config-buttons">
                                        <div className="config-grid">
                                            {regionConfig.features.cpfCnpj && (
                                                <button
                                                    className={`config-btnPDV ${cpfCnpjValue !== "" ? 'active' : ''}`}
                                                    disabled={!savedFormaEntrega}
                                                    onClick={() => setShowModalCpfCnpj(!showModalCpfCnpj)}
                                                >
                                                    CPF/CNPJ
                                                </button>
                                            )}
                                            <button
                                                className={`config-btnPDV ${desconto > 0 ? 'active' : ''}`}
                                                disabled={itensCarrinho.length === 0}
                                                onClick={() => setShowModalDesconto(true)}
                                            >
                                                {t('pdv:cart.discount')}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Botão principal: sempre abre o modal de pagamento (Lançar
                                        Pagamentos), igual nos 3 tipos - confirmar lá já finaliza
                                        o pedido sozinho (ver onPaymentConfirmed no ModalPagamentos). */}
                                    <button
                                        className="main-order-btn"
                                        onClick={() => setShowModalPagamentos(false)}
                                        type="button"
                                        disabled={!savedFormaEntrega || itensCarrinho.length === 0 || isSubmittingOrder}
                                    >
                                        {isSubmittingOrder
                                            ? t('pdv:confirmation.processing')
                                            : t('pdv:cart.continue', 'Continuar')}
                                    </button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                <Suspense fallback={null}>
                    <ModalDesconto
                        isOpen={showModalDesconto}
                        onClose={() => setShowModalDesconto(false)}
                        onApply={(value) => setDesconto(value)}
                        subtotal={subTotal}
                        currentDiscount={desconto}
                    />
                </Suspense>
                {selectedItem && (
                    <Suspense fallback={null}>
                        <ModalAdicionais
                            show={showAdicionaisModal}
                            onClose={() => { setShowAdicionaisModal(false); setSelectedItem(null); setEditingCartItem(null); }}
                            item={selectedItem}
                            idEmpresa={idEmpresa}
                            nomeEmpresaForUrl={nomeEmpresaForUrl}
                            quantidades={quantidades}
                            setQuantidades={setQuantidades}
                            adicionaisCompletos={adicionaisCompletos}
                            setAdicionaisCompletos={setAdicionaisCompletos}
                            handleFinalizarAdicionais={handleFinalizarAdicionais}
                        />
                    </Suspense>
                )}
            </Teste>
        </PermissionGate>
    );
};

export default Pdv;

